export const WIDGET_COLOR_TYPE = {
  colored: 0,
  colorless: 1
}
